/**
 * Helpers for the notes detail modal (CTA labels, etc.).
 */
import { feedEventLinkLabel } from "@/features/feed/feedLinks";
import type { FeedEvent } from "@/types/feed";

/** Label for the modal's primary deep-link, matching the note's destination. */
export function noteCtaLabel(
  href: string | null,
  event?: Pick<FeedEvent, "reference_type">,
): string {
  if (!href) return "View";
  if (event?.reference_type === "booking") return feedEventLinkLabel(event);
  if (
    event?.reference_type === "rate" ||
    event?.reference_type === "rate_card"
  ) {
    return feedEventLinkLabel(event);
  }
  if (/^\/bookings\/[^/?]+$/.test(href)) return "View booking";
  if (href.startsWith("/rates/")) return "View rate card";
  if (href.startsWith("/bookings")) return "View bookings";
  return "View";
}
